import { useState } from "react";
import { useStaffCard } from "../state/staffCardState";
import { useCheckAPI } from "../hooks/useCheckAPI";

export const useStaffInfo = (id, enabled = true) => {
  const [staffCard, setStaffCard] = useState({
    filter: {},
    staff: {},
  });

  // Fetch the staff card
  const { isSuccess, data } = useStaffCard(id, enabled);

  // Success Function
  const successFunc = () => setStaffCard(data.data.data.data.data);
  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);
  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return staffCard;
};
